import React, { useState, useMemo } from 'react'
import {
   Typography,
   Button,
   FormControl,
   InputLabel,
   Select,
   OutlinedInput,
   FormHelperText,
   MenuItem,
   IconButton,
   Grid,
   Modal,
   Paper
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import TooltipInputError from '../../toolTip/ToolTipInputError'
import TRANSLATE, { VALUES, REGEXP, OPERACIONES_SUBDOMINIOS } from 'utils/constants'
import Utils from 'utils/utils'
import { IconsSelector } from '../../materialIcon/IconsSelector'
// dropzone
import Dropzone from 'react-dropzone'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'

import Tooltip from '@material-ui/core/Tooltip'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import uploadChange from '../../../images/icons/uploadChange.svg'
import uploadSave from '../../../images/icons/uploadSave.svg'
import { getFromApi } from 'actions'
import { useEffect } from 'react'
import { useHasOperation } from 'hooks/useHasOperation'

const formContainerStyle = {
   display: 'flex',
   flexDirection: 'column',
   justifyContent: 'space-between',
   alignItems: 'center',
   width: '95%',
   margin: '0 auto 10px'
}

const useStyles = makeStyles(theme => ({
   formControl: {
      width: '100%',
      textAlign: 'initial',
      fontSize: 14,
      '&:not(:first-child)': {
         marginTop: 20
      }
   },
   helperText: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      fontSize: 11
   },
   formControlTextArea: {
      width: '100%',
      textAlign: 'initial',
      fontSize: 14,
      '&:not(:first-child)': {
         marginTop: 20
      }
   },
   button: {
      width: '140px',
      height: 40,
      marginTop: 20,
      color: 'white',
      background: '#3264DC'
   },
   formCleanButton: {
      color: '#3264DC',
      border: '1px solid #3264DC',
      fontWeight: 'bold',
      marginTop: 20,
      width: '140px'
   },
   formContainer: formContainerStyle,
   form: {
      ...formContainerStyle,
      paddingTop: '1rem'
   },
   titleOne: {
      margin: '20px 0 15px 9px',
      fontStyle: 'normal',
      fontSize: 14,
      alignSelf: 'start',
      color: '#8A8FAB',
      fontWeight: 400
   },

   containerButtonSubmit: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
   },

   // dropzone
   modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,.5)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #cecece',
      borderRadius: '4px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 1, 3),
      maxWidth: '550px'
   },
   confirmModalContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1.6rem 3rem',
      gap: '1rem',
      paddingBottom: '5rem'
   },
   iconContainer: {
      alignSelf: 'center',
      marginBottom: 16
   },
   warningIcon: {
      color: '#fe6320',
      fontSize: 68
   },

   containerIconImage: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
   },

   uploadImage: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      borderRadius: '0px',
      border: '1px solid #8A8FAB8D',
      borderRadius: '4px',
      padding: '10px',
      color: '#7a7575',
      marginTop: '10px',
      '&:hover': {
         cursor: 'pointer',
         backgroundColor: 'none',
         borderRadius: '4px'
      }
   },
   uploadImage2: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      borderRadius: '0px',
      border: '1px solid #f44336',
      borderRadius: '4px',
      padding: '10px',
      color: '#7a7575',
      marginTop: '10px',
      '&:hover': {
         cursor: 'pointer',
         backgroundColor: 'none',
         borderRadius: '4px'
      }
   },
   imageText: {
      color: '#7a7575'
   },

   imageText2: {
      color: '#7a7575'
   },
   errorImg: {
      color: '#f44336',
      fontSize: '11px',
      marginTop: '1px'
   },

   iconImage: {
      fontSize: 24
   },

   // modal
   modalContainer: {
      backgroundColor: '#F9FAFC',
      width: '45%',
      right: 0,
      float: 'right',
      position: 'absolute',
      borderRadius: 0
   },

   uploadIconModal: {
      backgroundColor: '#FFFFFF',
      color: '#43496A',
      width: '150px',
      height: '150px',
      marginBottom: '20px',
      '&:hover': {
         cursor: 'pointer'
      }
   },

   modalContent: {
      backgroundColor: '#F9FAFC',
      height: '100vh',
      borderRadius: 0
   },

   dropZoneAreaModal: {
      paddingTop: '45%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center'
   },

   topBoxModal: {
      position: 'absolute',
      width: '100%',
      top: '20px',
      marginRight: '20px',
      display: 'flex',
      justifyContent: 'center'
   },

   topBoxContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '95%',
      borderBottom: '1px solid #A1A4B5'
   },

   closeIcon: {
      marginRight: 10,
      marginTop: -1,
      color: '#B1B5C8',
      '& span': { color: '#3264DC', fontWeight: 600 },
      '&:hover': {
         cursor: 'pointer'
      }
   },

   spanTitleIcon: {
      display: 'block',
      color: '#43496A',
      fontWeight: '500',
      fontSize: '18px'
   },
   spanIconClick: {
      borderBottom: '1px solid #43496A',
      cursor: 'pointer'
   }
}))

const NO_MORE_THAN_50_CHARACTERS_MESSAGE = Utils.noMoreThanNCharacters(50)
const NO_MORE_THAN_255_CHARACTERS_MESSAGE = Utils.noMoreThanNCharacters(255)

const INITIAL_SUBDOMAIN_FORM_VALIDATION = {
   name: false,
   description: false,
   status: false,
   icon: false,
   file: false,
   map: false
}

const validRequired = value => !value || value === ''

const validationsFields = {
   name: value => value.length > 50 || validRequired(value),
   // name: value => value.length > 50 || validRequired(value) || !REGEXP.VALIDATION_NAME.exec(value),
   description: value => value.length > 255 || validRequired(value),
   status: validRequired,
   icon: validRequired,
   file: validRequired,
   map: validRequired
}

const createValidationSchema = type =>
   type === VALUES.FORM_BEHAVIOR.REGISTER
      ? Object.assign(validationsFields, { status: () => false })
      : validationsFields

const SubdomainForm = React.memo(
   ({ formBehavior, formData, setForm, actionSubmit, cleanCallback, setShowError, setTextError, editTable }) => {
      const classes = useStyles()
      const [invalid, setInvalid] = useState(INITIAL_SUBDOMAIN_FORM_VALIDATION)
      const validations = createValidationSchema(formBehavior)
      // console.log('formData', formData)
      const isSearch = useMemo(() => formBehavior === VALUES.FORM_BEHAVIOR.SEARCH, [formBehavior])
      
      const CONSULTAR_SUBDOMINIO = useHasOperation(OPERACIONES_SUBDOMINIOS.CONSULTAR_SUBDOMINIO)
      const REGISTRAR_SUBDOMINIO = useHasOperation(OPERACIONES_SUBDOMINIOS.REGISTRAR_SUBDOMINIO)

      function cleanForm() {
         cleanCallback()
         setInvalid(INITIAL_SUBDOMAIN_FORM_VALIDATION)
      }

      const validateFields = (name, value) => {
         const isInvalidFn = name in validations ? validations[name] : () => {}
         const isInvalid = isInvalidFn(value)
         if (isInvalid) {
            setInvalid(inv => ({
               ...inv,
               [name]: true
            }))
         } else if (invalid[name]) {
            setInvalid(inv => ({
               ...inv,
               [name]: false
            }))
         }
         // if (name === 'name' || invalid[name]) {
         //     !REGEXP.VALIDATION_NAME.exec(value) && setInvalid({ ...invalid, name: true })
         // }
      }

      const addValuesToMemory = e => {
         const { name, value } = e.target
         if (!isSearch || name === 'type') {
            validateFields(name, value)
         }
         setForm(prevFormData => ({
            ...prevFormData,
            [name]: name === 'name' ? value.toUpperCase() : value
         }))
      }

      const registerSubdomains = type => {
         const newValidations = {}
         let isInvalidField = false
         for (const key in INITIAL_SUBDOMAIN_FORM_VALIDATION) {
            const isInvalid = validations[key](formData[key])
            newValidations[key] = isInvalid
            if (isInvalid && !isInvalidField) {
               isInvalidField = isInvalid
            }
         }
         if (isInvalidField) {
            setInvalid(prev => {
               return { ...prev, ...newValidations }
            })
         } else {
            actionSubmit(type)
         }
      }

      const actionSubmitEvent = e => {
         e.preventDefault()
         switch (formBehavior) {
            case VALUES.FORM_BEHAVIOR.REGISTER: {
               registerSubdomains(VALUES.FORM_BEHAVIOR.REGISTER)
               break
            }
            case VALUES.FORM_BEHAVIOR.SEARCH: {
               actionSubmit(VALUES.FORM_BEHAVIOR.SEARCH)
               break
            }
            case VALUES.FORM_BEHAVIOR.EDIT: {
               registerSubdomains(VALUES.FORM_BEHAVIOR.EDIT)
               break
            }
            default:
               break
         }
      }

      const handleIconSelected = icon => {
         if (icon !== '') {
            setInvalid(inv => ({
               ...inv,
               icon: false
            }))
         }
         setForm(old => ({
            ...old,
            icon
         }))
      }

      // dropzone
      const ICON_SIZE = 20000000 // Tamaño de las imagenes en bytes
      const ACCEPTED_FORMATS = ['.png'] // formato de las imagenes de subdominio

      const [temporalFile, setTemporalFile] = useState(null)
      const [confirmationMessage, setConfirmationMessage] = useState(false)

      const [showSuccess, setShowSuccess] = useState(false)
      const [openModal, setOpenModal] = useState(false)
      const [iconConfirm, setIconConfirm] = useState(false)
      const [iconStateChange, setIconStateChange] = useState(true)

      const handleFileAdd = (acceptedFiles, fileRejections) => {
         if (fileRejections.length === 0) {
            formData.file = acceptedFiles[0]
            formData.status = 'A'
            setTemporalFile(acceptedFiles)
            setConfirmationMessage(true)
            setIconStateChange(false)
         } else {
            setShowError(true)
            if (fileRejections[0].errors[0].code == 'file-too-large') {
               const textoError = 'El archivo de imagen sobrepasa el peso permitido'
               setTextError(textoError)
            } else {
               const textoError = 'La extensión no es válida'
               setTextError(textoError)
            }
         }
      }

      const uploadFile = () => {
         setConfirmationMessage(false)
         setIconConfirm(true)
         setShowSuccess(true)
      }

      const confirmUploadFile = () => {
         setIconConfirm(false)
         setOpenModal(false)
         setIconStateChange(true)
      }

      const cancelFileUpload = () => {
         setConfirmationMessage(false)
         setIconStateChange(true)
         setTemporalFile(null)
      }

      const closeError = () => {
         setShowError(false)
      }
      const closeSucces = () => {
         setShowSuccess(false)
      }

      const ConfirmationMessage = () => {
         return (
            <Grid
               container
               direction="column"
               style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10
               }}
            >
               <Typography style={{ width: '400px' }} variant="subtitle1">
                  ¿Desea cargar el ícono {temporalFile[0].name} ?
               </Typography>

               <Grid
                  item
                  container
                  spacing={10}
                  style={{
                     justifyContent: 'center',
                     alignItems: 'center',
                     marginTop: 10
                  }}
               >
                  <Button
                     variant="outlined"
                     color="primary"
                     style={{ marginRight: 30, width: '158px' }}
                     onClick={cancelFileUpload}
                  >
                     Cancelar
                  </Button>
                  <Button
                     variant="contained"
                     color="primary"
                     style={{ width: '158px' }}
                     onClick={() => uploadFile(temporalFile[0].name)}
                  >
                     Aceptar
                  </Button>
               </Grid>
            </Grid>
         )
      }

      const UploadVideoMessage = () => {
         return (
            <Grid
               container
               direction="column"
               style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10
               }}
            >
               {iconConfirm == false && (
                  <Typography style={{ width: '400px' }} variant="subtitle1">
                     <span className={classes.spanTitleIcon}>Arrastre y suelte aquí, su ícono.</span>
                     <Dropzone
                        onDrop={(acceptedFiles, fileRejections) => handleFileAdd(acceptedFiles, fileRejections)}
                        maxFiles={1}
                        accept={ACCEPTED_FORMATS}
                        maxSize={ICON_SIZE}
                     >
                        {({ getRootProps, getInputProps }) => (
                           <div style={{ display: 'inline' }} {...getRootProps()}>
                              <input {...getInputProps()} />
                              <span className={classes.spanIconClick}>o haga click</span>
                           </div>
                        )}
                     </Dropzone>{' '}
                     para seleccionarlo desde su equipo
                  </Typography>
               )}

               {iconConfirm && (
                  <>
                     <Typography variant="subtitle1">
                        ¡el ícono {temporalFile[0].name} ha sido cargado con éxito!
                     </Typography>
                     <Grid
                        item
                        container
                        spacing={10}
                        style={{
                           justifyContent: 'center',
                           alignItems: 'center',
                           marginTop: 10
                        }}
                     >
                        <Button variant="contained" color="primary" onClick={confirmUploadFile}>
                           Aceptar
                        </Button>
                     </Grid>
                  </>
               )}
            </Grid>
         )
      }

      const AddVideoModal = () => {
         return (
            <Modal open={openModal} disableEscapeKeyDown={false}>
               <div className={classes.modalContainer}>
                  <Paper elevation={6} className={classes.modalContent}>
                     <div className={classes.dropZoneAreaModal}>
                        <div className={classes.topBoxModal}>
                           <div className={classes.topBoxContainer}>
                              <Typography style={{ color: '#3264DC' }}>Cargar ícono</Typography>
                              <Tooltip title="Cerrar">
                                 <IconButton aria-label="Cerrar" onClick={() => setOpenModal(false)}>
                                    <HighlightOffIcon className={classes.closeIcon} />
                                 </IconButton>
                              </Tooltip>
                           </div>
                        </div>
                        <Dropzone
                           onDrop={(acceptedFiles, fileRejections) => handleFileAdd(acceptedFiles, fileRejections)}
                           maxFiles={1}
                           accept={ACCEPTED_FORMATS}
                           maxSize={ICON_SIZE}
                        >
                           {({ getRootProps, getInputProps }) => (
                              <div {...getRootProps()}>
                                 <input {...getInputProps()} />

                                 <IconButton aria-label="upload-video" className={classes.uploadIconModal}>
                                    {iconStateChange && <CloudUploadIcon style={{ fontSize: 60 }} />}

                                    {confirmationMessage && (
                                       <div>
                                          <img src={uploadChange} alt="" />
                                       </div>
                                    )}
                                    {iconConfirm && (
                                       <div>
                                          <img src={uploadSave} alt="" />
                                       </div>
                                    )}
                                 </IconButton>
                              </div>
                           )}
                        </Dropzone>
                        {confirmationMessage ? <ConfirmationMessage /> : <UploadVideoMessage />}
                     </div>
                  </Paper>
               </div>
            </Modal>
         )
      }

      const IconImage = ({ error }) => {
         let nameShow = ''

         if (typeof formData.file === 'string') {
            const urlString = formData.file
            const newurlString = urlString.split('').reverse().join('')
            const field = newurlString.split('/')
            const nameField = field[0]
            nameShow = nameField.split('').reverse().join('')
         } else {
            nameShow = ''
         }
         return (
            <>
               <div
                  className={error == true ? classes.uploadImage2 : classes.uploadImage}
                  onClick={() => setOpenModal(true)}
                  name="file"
               >
                  {formBehavior == 'EDIT' ? (
                     <Typography className={error == true ? classes.imageText2 : classes.imageText}>
                        {formData.file.path ? `${formData.file.path}` : `${nameShow}`}
                     </Typography>
                  ) : (
                     <Typography className={error == true ? classes.imageText2 : classes.imageText}>
                        {' '}
                        {temporalFile ? `${temporalFile[0].name}` : 'Cargar ícono Mundo Mutual*'}{' '}
                     </Typography>
                  )}
                  <CloudUploadIcon className={classes.iconImage} />
               </div>
               {error && <p className={classes.errorImg}>El icono mundo mutual es obligatorio</p>}
            </>
         )
      }

      const SelectMapaMundo = () => {
         const [dataMaps, setDataMaps] = useState([])
         // console.log('dataMaps', dataMaps)
         async function getMaps() {
            const url = `${process.env.REACT_APP_SUBDOMAIN_API}/subdomains/map`
            const fetchDataMap = await getFromApi(url)
            const dataMapsMuta = fetchDataMap.map(function (item) {
               return {
                  label: item.name,
                  value: item.code
               }
            })
            setDataMaps(dataMapsMuta)
         }

         const selectOptions = [
            {
               label: 'Mapa analitica',
               value: 'Mapa analitica'
            },
            {
               label: 'Mapa financiera',
               value: 'Mapa financiera'
            },
            {
               label: 'Mapa acceso a servicios de salud',
               value: 'Mapa acceso a servicios de salud'
            },
            {
               label: 'Mapa redes integrales',
               value: 'Mapa redes integrales'
            },
            {
               label: 'Mapa mercadeo',
               value: 'Mapa mercadeo'
            },
            {
               label: 'Mapa general',
               value: 'Mapa general'
            }
         ]

         useEffect(() => {
            getMaps()
         }, [])

         // preguntar por el valor del select en editar

         return (
            <>
               {formBehavior == 'EDIT' ? (
                  <>
                     <InputLabel htmlFor="map-type">Mapa Mundo Mutual* </InputLabel>
                     <Select
                        value={formData?.map}
                        onChange={addValuesToMemory}
                        size="small"
                        name="map"
                        label="Mapa Mundo Mutual*"
                        inputProps={{
                           name: 'map',
                           id: 'map-type'
                        }}
                     >
                        <MenuItem aria-label="None" value={''} />
                        {dataMaps.map(option => (
                           <MenuItem key={option.value} value={option.value}>
                              {option.label}
                           </MenuItem>
                        ))}
                     </Select>
                     <FormHelperText className={classes.helperText}>
                        {invalid.type && 'El campo Mapa Mundo Mutual es obligatorio'}
                     </FormHelperText>
                  </>
               ) : (
                  <>
                     <InputLabel htmlFor="map-type">Mapa Mundo Mutual* </InputLabel>
                     <Select
                        value={formData?.map}
                        onChange={addValuesToMemory}
                        size="small"
                        name="map"
                        label="Mapa Mundo Mutual*"
                        inputProps={{
                           name: 'map',
                           id: 'map-type'
                        }}
                     >
                        <MenuItem aria-label="None" value={''} />
                        {dataMaps.map(option => (
                           <MenuItem key={option.value} value={option.value}>
                              {option.label}
                           </MenuItem>
                        ))}
                     </Select>
                     <FormHelperText className={classes.helperText}>
                        {invalid.type && 'El campo Mapa Mundo Mutual es obligatorio'}
                     </FormHelperText>
                  </>
               )}
            </>
         )
      }

      return (
         <div className={classes.formContainer}>
            <AddVideoModal />
            <Typography className={classes.titleOne}>
               <b> Completa los campos </b>{' '}
            </Typography>
            <form className={classes.form} encType="multipart/form-data">
               <FormControl variant="outlined" size="small" className={classes.formControl} error={invalid.name}>
                  <InputLabel htmlFor="outlined-adornment-amount">
                     {`Nombre del subdominio ${!isSearch ? '*' : ''}`}
                  </InputLabel>
                  <OutlinedInput
                     error={invalid.name}
                     value={formData.name}
                     onChange={addValuesToMemory}
                     label="Nombre del subdominio"
                     name="name"
                     size="small"
                     endAdornment={
                        (invalid.name && <TooltipInputError title={TRANSLATE.FORM.ENTER_VALID_NAME_MESSAGE} />) ||
                        (formData.name.length === 50 && (
                           <TooltipInputError title={NO_MORE_THAN_50_CHARACTERS_MESSAGE} />
                        ))
                     }
                     inputProps={{ maxLength: 50 }}
                  />
                  {invalid.name && (
                     <FormHelperText className={classes.helperText}>
                        {!formData.name
                           ? TRANSLATE.FORM.MANDATORY_SUBDOMAIN_MESSAGE
                           : 'Por favor ingrese un nombre válido'}
                     </FormHelperText>
                  )}
               </FormControl>
               {!isSearch && (
                  <>
                     <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.formControlTextArea}
                        error={invalid.description}
                     >
                        <InputLabel htmlFor="outlined-adornment-amount">
                           {`Descripción del Subdomino ${!isSearch ? '*' : ''}`}
                        </InputLabel>
                        <OutlinedInput
                           error={invalid.description}
                           value={formData.description}
                           onChange={addValuesToMemory}
                           label="Descripción del Subdomino  "
                           name="description"
                           endAdornment={
                              (invalid.description && (
                                 <TooltipInputError title={TRANSLATE.FORM.ENTER_VALID_NAME_MESSAGE} />
                              )) ||
                              (formData?.description?.length === 255 && (
                                 <TooltipInputError title={NO_MORE_THAN_255_CHARACTERS_MESSAGE} />
                              ))
                           }
                           multiline
                           rows={4}
                           inputProps={{ maxLength: 255 }}
                        />
                        <FormHelperText className={classes.helperText}>
                           {invalid.description && 'El campo Descripción de la Operación es obligatorio'}
                        </FormHelperText>
                     </FormControl>
                     <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        size="small"
                        error={invalid.status}
                     >
                        <IconsSelector
                           value={formData.icon}
                           error={invalid.icon}
                           messageError="El icono del Subdominio es obligatorio"
                           variant="outlined"
                           size="small"
                           styleHelperText={classes.helperText}
                           handleIconSelected={handleIconSelected}
                        />
                     </FormControl>
                     {/* Dropzone */}
                     <FormControl variant="outlined" className={classes.formControl} margin="dense" error={invalid.map}>
                        <SelectMapaMundo />
                     </FormControl>
                     <FormControl className={classes.containerIconImage}>
                        <IconImage error={invalid.file} value={formData.file}></IconImage>
                     </FormControl>
                     {/* DropZone */}
                  </>
               )}
               {formBehavior !== VALUES.FORM_BEHAVIOR.REGISTER && (
                  <FormControl variant="outlined" className={classes.formControl} size="small" error={invalid.status}>
                     <InputLabel htmlFor="outlined-type-native-simple">
                        {`Estado del Subdominio ${!isSearch ? '*' : ''}`}
                     </InputLabel>
                     <Select
                        value={formData.status}
                        onChange={addValuesToMemory}
                        label="Estado del Subdominio"
                        size="small"
                        name="status"
                        inputProps={{
                           name: 'status',
                           id: 'outlined-type-native-simple'
                        }}
                     >
                        <MenuItem aria-label="None" value={''} />
                        {VALUES.STATUS_OPTIONS.map(option => (
                           <MenuItem key={option.value} value={option.value}>
                              {option.label}
                           </MenuItem>
                        ))}
                     </Select>
                     <FormHelperText className={classes.helperText}>
                        {invalid.status && 'El campo Estado del Subdominio es obligatorio'}
                     </FormHelperText>
                  </FormControl>
               )}
               <div className={classes.containerButtonSubmit}>
                  <Button
                     classes={{
                        root: classes.formCleanButton
                     }}
                     variant="outlined"
                     onClick={cleanForm}
                  >
                     {TRANSLATE.BUTTONS.CLEAN}
                  </Button>
                  <Button
                     type="submit"
                     variant="contained"
                     color="primary"
                     classes={{
                        root: classes.button
                     }}
                     onClick={actionSubmitEvent}
                     disabled={isSearch ? !CONSULTAR_SUBDOMINIO : !REGISTRAR_SUBDOMINIO}
                  >
                     {formBehavior === VALUES.FORM_BEHAVIOR.EDIT
                        ? TRANSLATE.BUTTONS.EDIT
                        : isSearch
                        ? TRANSLATE.BUTTONS.SEARCH
                        : TRANSLATE.BUTTONS.SAVE}
                  </Button>
               </div>
            </form>
         </div>
      )
   }
)

export default SubdomainForm
